var _path, _path2, _g, _g2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValue01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 43.7824C21 43.3021 21.2663 42.8614 21.6915 42.638V42.638C36.7507 34.7255 54.7382 34.7255 69.7974 42.638V42.638C70.2226 42.8614 70.4889 43.3021 70.4889 43.7824V107.276C70.4889 108.86 68.7367 109.815 67.4056 108.958V108.958C54.2145 100.462 37.2744 100.462 24.0833 108.958L22.6441 109.885C21.9343 110.342 21 109.832 21 108.988V43.7824Z",
    fill: "url(#paint0_linear_603_1235)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43.7824C67 43.3021 67.2663 42.8614 67.6915 42.638V42.638C82.7507 34.7255 100.738 34.7255 115.797 42.638V42.638C116.223 42.8614 116.489 43.3021 116.489 43.7824V108.988C116.489 109.832 115.555 110.342 114.845 109.885L112.135 108.14C99.7177 100.142 83.7712 100.142 71.3536 108.14V108.14C69.4741 109.35 67 108.001 67 105.765V43.7824Z",
    fill: "url(#paint1_linear_603_1235)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_603_1235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 33.7824C14 33.3021 14.2663 32.8614 14.6915 32.638V32.638C29.7507 24.7255 47.7382 24.7255 62.7974 32.638V32.638C63.2226 32.8614 63.4889 33.3021 63.4889 33.7824V97.2763C63.4889 98.8595 61.7367 99.8151 60.4056 98.9578V98.9578C47.2145 90.4618 30.2744 90.4618 17.0833 98.9578L15.6441 99.8848C14.9343 100.342 14 99.8324 14 98.9881V33.7824Z",
    fill: "url(#paint2_linear_603_1235)",
    fillOpacity: 0.69
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_603_1235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 33.7824C60 33.3021 60.2663 32.8614 60.6915 32.638V32.638C75.7507 24.7255 93.7382 24.7255 108.797 32.638V32.638C109.223 32.8614 109.489 33.3021 109.489 33.7824V98.9881C109.489 99.8324 108.555 100.342 107.845 99.8848L105.135 98.1396C92.7177 90.1419 76.7712 90.1419 64.3536 98.1396V98.1396C62.4741 99.3502 60 98.0008 60 95.7652V33.7824Z",
    fill: "url(#paint3_linear_603_1235)",
    fillOpacity: 0.69
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 63C23 61.3431 24.3431 60 26 60L40 60C41.6569 60 43 61.3431 43 63V63C43 64.6569 41.6569 66 40 66H26C24.3431 66 23 64.6569 23 63V63Z",
    fill: "url(#paint4_linear_603_1235)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 73C33 71.3431 34.3431 70 36 70L50 70C51.6569 70 53 71.3431 53 73V73C53 74.6569 51.6569 76 50 76H36C34.3431 76 33 74.6569 33 73V73Z",
    fill: "url(#paint5_linear_603_1235)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82 72C82 70.3431 83.3431 69 85 69L99 69C100.657 69 102 70.3431 102 72V72C102 73.6569 100.657 75 99 75H85C83.3431 75 82 73.6569 82 72V72Z",
    fill: "url(#paint6_linear_603_1235)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70 81C70 79.3431 71.3431 78 73 78L87 78C88.6569 78 90 79.3431 90 81V81C90 82.6569 88.6569 84 87 84H73C71.3431 84 70 82.6569 70 81V81Z",
    fill: "url(#paint7_linear_603_1235)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0575 48.8331C91.3654 50.3874 88.5021 50.4677 87.6619 49.0126C86.8218 47.5574 88.3231 45.1178 91.0151 43.5636C93.7071 42.0093 100.441 41.6348 100.441 41.6348C100.441 41.6348 96.7495 47.2789 94.0575 48.8331Z",
    fill: "url(#paint8_linear_603_1235)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9044 48.8331C80.5965 50.3874 83.4599 50.4677 84.3 49.0126C85.1401 47.5574 83.6389 45.1178 80.9468 43.5636C78.2548 42.0093 71.5213 41.6348 71.5213 41.6348C71.5213 41.6348 75.2124 47.2789 77.9044 48.8331Z",
    fill: "url(#paint9_linear_603_1235)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.1787 51C87.2833 51 88.1787 51.7296 88.1787 52.6296V60.3704C88.1787 61.2704 87.2833 62 86.1787 62C85.0741 62 84.1787 61.2704 84.1787 60.3704V52.6296C84.1787 51.7296 85.0741 51 86.1787 51Z",
    fill: "#6B46F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_603_1235",
    x: 10,
    y: 22.7036,
    width: 57.4888,
    height: 81.353,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_603_1235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_603_1235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_603_1235",
    x: 56,
    y: 22.7036,
    width: 57.4888,
    height: 81.353,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_603_1235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_603_1235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_603_1235",
    x1: 45.7444,
    y1: 30,
    x2: 45.7444,
    y2: 110.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A56FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6641EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_603_1235",
    x1: 91.7444,
    y1: 30,
    x2: 91.7444,
    y2: 110.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A56FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6641EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_603_1235",
    x1: 38.7444,
    y1: 20,
    x2: 38.7444,
    y2: 100.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3C7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DED5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_603_1235",
    x1: 84.7444,
    y1: 20,
    x2: 84.7444,
    y2: 100.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3C7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DED5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_603_1235",
    x1: 41,
    y1: 68,
    x2: 31.5,
    y2: 58.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4B4FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_603_1235",
    x1: 51,
    y1: 78,
    x2: 41.5,
    y2: 68.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4B4FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_603_1235",
    x1: 100,
    y1: 77,
    x2: 90.5,
    y2: 67.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4B4FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_603_1235",
    x1: 88,
    y1: 86,
    x2: 78.5,
    y2: 76.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4B4FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_603_1235",
    x1: 100.441,
    y1: 41.6348,
    x2: 87.6619,
    y2: 49.0126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E5AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_603_1235",
    x1: 71.5213,
    y1: 41.6348,
    x2: 84.3,
    y2: 49.0126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E5AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValue01);
export default __webpack_public_path__ + "static/media/value-01.c894dfd468d4a67857409bfabe183825.svg";
export { ForwardRef as ReactComponent };